import React from "react";
// Confirmation Modal

// Mui
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

// Custom
import ContainedButton from "../../forms/button/ContainedButton";

// React icons
import { FiAlertTriangle } from "react-icons/fi";
import { UnifiedIcon } from "../Icon/UnifiedIcon";

const ConfirmationModal = ({
  title,
  body,
  confirmModal,
  onClose,
  onClick,
  isLoading = false,
}: {
  title?: string;
  body?: string;
  confirmModal: boolean;
  onClose: () => void;
  onClick: () => void;
  isLoading?: boolean;
}) => {
  return (
    <Dialog
      open={confirmModal}
      maxWidth={false}
      sx={{
        zIndex: 1500,
        "& .MuiPaper-root": {
          width: "400px",
          maxWidth: "none",
        },
      }}
    >
      <DialogTitle
        color="#FF4D4D"
        sx={{ display: "flex", alignItems: "center", gap: "5px" }}
      >
        <UnifiedIcon icon={FiAlertTriangle} color="#FF4D4D" fontSize="25px" />
        {title ? title : "Alert"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {body
            ? body
            : "Are you sure want to proceed without saving your custom fields?"}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <ContainedButton
          label={"Yes"}
          sx={{
            width: "fit-content",
            fontWeight: 600,
            color: "#ffffff",
          }}
          onClick={onClick}
          loading={isLoading}
        />
        <ContainedButton
          label={"No"}
          bgColor={"linear-gradient(180deg, #FF7F7F 0%, #FF4D4D 100%)"}
          sx={{
            fontWeight: 600,
            color: "#ffffff",
          }}
          onClick={onClose}
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
